import { useMemo } from 'react';
import { Location, matchRoutes, useLocation } from 'react-router-dom';

import { assertUnreachable } from '../../../util/guards';
import { AppRoutePatterns, routePathObjects } from '../../routes';
import { logger } from '../../util/logger';
import { renderModel } from '../../util/renderModel';
import { Page } from '../types';

const isFullWidth = renderModel.isFullWidth();

export const useCurrentPage = (): Page => {
  const location = useLocation();
  return useMemo(() => getCurrentPage(location), [location]);
};

function getCurrentPage(location: Location): Page {
  const matchedRoutes = matchRoutes(routePathObjects, location);

  if (!matchedRoutes) {
    const error = new Error(`Current Router Page is not defined: Location: ${JSON.stringify(location)}`);
    logger.error({
      message: error.message,
      error,
    });

    // return default view
    return isFullWidth ? Page.Chatbot : Page.Home;
  }

  const [{ route }] = matchedRoutes;

  switch (route.path) {
    case AppRoutePatterns.Home: {
      // '/' path for chatbotFullPageRouter renders Chatbot(without article sidebar)
      return isFullWidth ? Page.Chatbot : Page.Home;
    }
    case AppRoutePatterns.Chatbot: {
      return Page.Chatbot;
    }
    case AppRoutePatterns.Search: {
      return Page.Search;
    }
    case AppRoutePatterns.ArticleById:
    case AppRoutePatterns.ArticleByUri: {
      return Page.Article;
    }
    default:
      assertUnreachable(route.path);
  }
}
